import React from 'react';
import PropTypes from 'prop-types';

import IOSInstructionScreenPng from 'assets/ios-pwa-install-screen.png';
import AndroidInstructionScreenPng from 'assets/android-pwa-install-screen.png';
import ShareIcon from '@chronos/components/Icons/ShareIcon';
import MoreIcon from '@chronos/components/Icons/MoreIcon';
import PlusInSquareIcon from '@chronos/components/Icons/PlusInSquareIcon';

import * as S from './styled';

const InstallInstruction = ({
  isIOS,
  isAndroid,
  isMac,
  isLinux,
  isWindows,
}) => {
  if (isIOS) {
    return (
      <S.InstallInstruction>
        <S.InstuctionLine>
          <S.InstructionText>
            To install the app click share on Safari browser
          </S.InstructionText>
          <ShareIcon
            shouldPadding
            size="large"
          />
        </S.InstuctionLine>
        <S.InstuctionLine>
          <S.InstructionText>Add to Home Screen</S.InstructionText>
          <PlusInSquareIcon
            shouldPadding
            size="large"
          />
        </S.InstuctionLine>
        <S.InstructionImage
          src={IOSInstructionScreenPng}
          alt="Install instruction"
        />
      </S.InstallInstruction>
    );
  }

  if (isAndroid || isMac || isLinux || isWindows) {
    return (
      <S.InstallInstruction>
        <S.InstuctionLine>
          <S.InstructionText>
            To install the app click "More" on Chrome browser
          </S.InstructionText>
          <MoreIcon
            shouldPadding
            size="large"
          />
        </S.InstuctionLine>
        <S.InstructionImage
          src={AndroidInstructionScreenPng}
          alt="Install instruction"
        />
      </S.InstallInstruction>
    );
  }
  return null;
};

InstallInstruction.propTypes = {
  isIOS: PropTypes.bool,
  isAndroid: PropTypes.bool,
  isMac: PropTypes.bool,
  isLinux: PropTypes.bool,
  isWindows: PropTypes.bool,
};
InstallInstruction.defaultProps = {
  isIOS: false,
  isAndroid: false,
  isMac: false,
  isLinux: false,
  isWindows: false,
};

export default InstallInstruction;
